const SI_SUFFIXES = ['', 'k', 'M', 'B', 'T']

export function formatSI(value: number, precision = 1): string {
  if (!Number.isFinite(value)) return String(value)
  const abs = Math.abs(value)
  let tier = 0
  let scaled = abs
  while (scaled >= 1000 && tier < SI_SUFFIXES.length - 1) {
    scaled /= 1000
    tier += 1
  }
  const sign = value < 0 ? '-' : ''
  const digits = tier === 0 ? 0 : precision
  return `${sign}${scaled.toFixed(digits)}${SI_SUFFIXES[tier]}`
}

export function formatSigned(value: number, precision = 1): string {
  const sign = value > 0 ? '+' : value < 0 ? '' : '±'
  return `${sign}${formatSI(value, precision)}`
}
